/**

Copyright (c) 2021, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="ion-page">
    <ion-header no-border>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">Nouveau Badge</h1>
      </ion-toolbar>
    </ion-header>



    <ion-content  class="mc-message-badge" color="primary" no-bounce>


      <div class="mc-white-container" >

        <div class="ion-text-center ion-margin-top" v-if="loader">
          <ion-icon size="large" color="light" class="rotating" name="md-sync"></ion-icon>
        </div>

        <div class="ion-text-center ion-margin-top" v-if="!loader && !badge">
          {{ $t('Badge.winBadge.none') }}
        </div>

        <div v-if="!loader && badge">
          <ion-row>
            <ion-col size="12">
              <p class="mc-message-text text-center" color="primary">{{ $t('Badge.winBadge.message') }} <br><strong>{{ badge.title }}</strong> </p>
            </ion-col>
            <ion-col size="12" class="d-flex justify-center align-center">
              <img style="width: 20%" :src="badge.pictures.icon" />
            </ion-col>
            <ion-col size="12" style="margin-top:15px">
              <img style="width: 100%" v-if="image" :src="image" :onload="setImage()"/>
            </ion-col>
          </ion-row>
          <!-- composant -> prochaine action -->
          <div class="mc-action-next">
            <ion-text color="secondary" class="d-flex justify-center">
              <h6><strong> {{ badge.text }}</strong></h6>
            </ion-text>
            <ion-card color="primary" style="margin-top:10px;">
              <ion-row>
                <ion-col size="12" style="padding:2px;">
                  <p class="text-center">{{ $t('Badge.winBadge.otherBadge.title') }}</p>
                </ion-col>
                <ion-col class="d-flex justify-center align-center">
                  <ion-button shape="round" size="small"  style="margin-top:-10px;margin-bottom:10px;" color="secondary" @click="redirectToMyBadges"> {{ $t('Badge.winBadge.otherBadge.button') }}</ion-button>
                </ion-col>
              </ion-row>
            </ion-card>
          </div>
          <!-- composant -> prochaine action -->

          <!-- checkbox -->
          <!--
          <div class="mc-checkbox d-flex bottom-checkbox">
            <ion-item lines="none">
              <ion-checkbox name="displayNone" color="primary"></ion-checkbox>
              <ion-label class="no-white-space">
                <p>{{ $t('Badge.checkbox.label') }}</p>
              </ion-label>
            </ion-item>
          </div>
          -->
        </div>
      </div>
      <!-- checkbox -->
      <!--
      <div class="d-flex justify-center" v-if="$store.state.badgeStore.statusBadges == ''">
      <ion-button  v-show="displayButton" shape="round" color="secondary">
              Afficher version allégée
      </ion-button>
      </div>
      -->
    </ion-content>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        badgeId: this.$route.query.id,
        loader : false,
        badge : null,
        image: null
      }
    },
    created() {
      this.badge = this.$store.getters.getWinBadge;
      if (this.badge.pictures.imageLight) {
        this.image = this.badge.pictures.imageLight;
      } else {
        this.image = this.badge.pictures.image;
      }

      /*
      this.$store.dispatch('getBadge', this.badgeId).then(resp => {
        this.badge = resp.data;
        this.loader = false;
      }).catch(error => {
        this.loader = false;
      })
       */
    },

    methods: {
      redirectToMyBadges() {
        this.$router.push({ name: "my-badges" });
      },
      setImage() {
        this.image = this.badge.pictures.image;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mc-action-next {
    padding: 0;
  }

  .no-white-space {
    white-space: normal !important;
    padding-left: 10px;
  }

  .mc-checkbox {
    justify-content: center;
  }

  .top-message {
    background-color: #f5f6fa;
    color: var(--ion-color-primary);
    padding: 15px 30px;
    margin-top: -30px;
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  .mc-image-waiting-badge {
    width: "100%";
    padding-top: 50px;
    background-size: cover;
  }
  .mc-message-text {
    font-size: 1rem;
    padding: 3px;
    color: var(--ion-color-primary);
  }
</style>
